import { getInternalConfig } from './window';
import { log } from './log';
import { ENABLER, PERMANENT_ENABLER } from './constants';
import { getParamValue } from './url';
/**
 * Checking of save command in GET params and saving the value to local storage.
 */
const permanentEnabler = () => {
    var _a, _b, _c;
    const paramValue = getParamValue(PERMANENT_ENABLER);
    // nothing in URL
    if (paramValue === null) {
        return;
    }
    const lastValue = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(ENABLER);
    if (
    // rule in URL is the same as the saved one (preventing console bloating)
    paramValue == lastValue ||
        // rule was already deleted
        (lastValue === null && paramValue === '')) {
        // do nothing
        return;
    }
    if (paramValue === '') {
        // blank string to remove the saved rule
        (_b = window.localStorage) === null || _b === void 0 ? void 0 : _b.removeItem(ENABLER);
        log(getInternalConfig(), undefined, undefined, 'Rule was removed from the local storage.');
    }
    else {
        // a string to save to the local storage
        (_c = window.localStorage) === null || _c === void 0 ? void 0 : _c.setItem(ENABLER, paramValue !== null && paramValue !== void 0 ? paramValue : '');
        log(getInternalConfig(), undefined, undefined, `Rule "${paramValue}" was saved to the local storage.`);
    }
};
export { permanentEnabler };
